import React from 'react'
import PropTypes from 'prop-types'
import { Textfit } from 'react-textfit'

import './RecommendationBox.css'
import ImmunizationRecommendation from '../../../../../../models/ImmunizationRecommendion/ImmunizationRecommendation'
import moment from 'moment'
import withPolyglot from '../../../../../common/withPolyglot'

const STATUS_COLORS = {
  late: '#ff6b63',
  current: '#f2cb30',
  future: '#eee'
}

function getColorForStatus (status) {
  switch (status) {
    case 'late':
      return STATUS_COLORS.late
    case 'current':
      return STATUS_COLORS.current
    default:
      return STATUS_COLORS.future
  }
}

function getRecommendationStatus (recommendation) {
  console.log(recommendation)
  const earliest = moment(new Date(recommendation.dateCriterion.earliest))
  const latest = moment(new Date(recommendation.dateCriterion.latest))
  const today = moment()
  if (today.isBetween(earliest, latest)) {
    return 'current'
  } else if (today.isAfter(latest)) {
    return 'late'
  } else {
    return 'future'
  }
}

// TODO Put next distance
const RecommendationBox = ({handleClick, recommendation, translate, clickDisabled, editMode}) => {
  return <div className='uk-height-small shot-grid-cell'>
    <div
      className={`recommendation uk-align-center ${!clickDisabled ? 'clickable' : ''}`}
      style={{borderColor: getColorForStatus(getRecommendationStatus(recommendation))}}
      onClick={handleClick}>
      <div className='content'>
        <Textfit className={editMode ? 'faded' : ''} min={11} max={14}>
          {translate('doseNumber')}: {recommendation.doseNumber}
        </Textfit>
        { !editMode ? <br className='hidden-on-small-screen' /> : null }
        <Textfit className={editMode ? 'faded' : ''} min={11} max={12}>
          <strong>{recommendation.getRecommendedDate('pt-PT')}</strong>
        </Textfit>
        { editMode ? <i className='fas fa-pen fa-2x uk-position-bottom-center bottom-margin' /> : null }
      </div>
    </div>
  </div>
}

RecommendationBox.propTypes = {
  handleClick: PropTypes.func.isRequired,
  recommendation: PropTypes.instanceOf(ImmunizationRecommendation).isRequired,
  clickDisabled: PropTypes.bool.isRequired
}

RecommendationBox.defaultProps = {
  clickDisabled: false,
  handleClick: () => { console.log('dummy') }
}

export default withPolyglot(RecommendationBox, 'recommendationBox')
